import { Skeleton, Stack } from "@mui/material";

const NewsHeroCardSkeleton = () => (
  <Stack spacing={1.5}>
    <Skeleton variant="rounded" width="100%" sx={{ aspectRatio: "3 / 2", height: "auto" }} />
    <Stack direction="row" spacing={1}>
      <Skeleton variant="rounded" width="25%" height="1.5rem" />
      <Skeleton variant="rounded" width="20%" height="1.5rem" />
    </Stack>
    <Skeleton variant="rounded" width="90%" height="1.5rem" />
    <Skeleton variant="rounded" width="70%" height="1rem" />
  </Stack>
);

export default NewsHeroCardSkeleton;
